/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'user-user-role': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M17.544 13.125l-3.794-3.75 3.794-3.75.893.881-2.9 2.869 2.9 2.869-.893.881zM13.75 18.75H12.5v-3.125c0-1.726-1.4-3.125-3.125-3.125h-3.75A3.125 3.125 0 002.5 15.625v3.125H1.25v-3.125a4.375 4.375 0 014.375-4.375h3.75a4.375 4.375 0 014.375 4.375v3.125zM7.5 2.5a3.125 3.125 0 110 6.25 3.125 3.125 0 010-6.25zm0-1.25a4.375 4.375 0 100 8.75 4.375 4.375 0 000-8.75z"/>'
  }
})
